import React from 'react';
import './OtpInputs.css';
import { allowedOtpKeys } from './../../../utils/allowedOtpKeys';
import { getDevice } from './../../../utils/getDevice';

const OtpInputs = props => {

    const onInputChange = (event, val) => {
        const keyCode = event.keyCode;
        event.persist();
        let inputs = document.getElementsByClassName('cd_input_otp');
        inputs[val].value = '';
        if (!allowedOtpKeys.includes(keyCode)) {
            setTimeout(() => {
                inputs[val].value = '';
            }, 10);
            return
        }
        setTimeout(() => {
            if (val < 5 && keyCode !== 8) {
                inputs[val].value = event.target.value;
                inputs[val + 1].focus();
            }
            if (val > 0 && keyCode === 8) {
                inputs[val].value = '';
                inputs[val - 1].focus();
            }
        }, 50)

    }

    const device = getDevice();
    let type;

    if(device === 'mobile'){
        type = 'tel';
    } else {
        type = 'number';
    }

    return (
        <>
            <input type={type} maxLength="1" size="1" min="0" max="9" pattern="[0-9]{1}" disabled={props.submitting} className="cd_input_otp" onKeyDown={event => onInputChange(event, 0)} />
            <input type={type} maxLength="1" size="1" min="0" max="9" pattern="[0-9]{1}" disabled={props.submitting} className="cd_input_otp" onKeyDown={event => onInputChange(event, 1)} />
            <input type={type} maxLength="1" size="1" min="0" max="9" pattern="[0-9]{1}" disabled={props.submitting} className="cd_input_otp" onKeyDown={event => onInputChange(event, 2)} />
            <input type={type} maxLength="1" size="1" min="0" max="9" pattern="[0-9]{1}" disabled={props.submitting} className="cd_input_otp" onKeyDown={event => onInputChange(event, 3)} />
            <input type={type} maxLength="1" size="1" min="0" max="9" pattern="[0-9]{1}" disabled={props.submitting} className="cd_input_otp" onKeyDown={event => onInputChange(event, 4)} />
            <input type={type} maxLength="1" size="1" min="0" max="9" pattern="[0-9]{1}" disabled={props.submitting} className="cd_input_otp" onKeyDown={event => onInputChange(event, 5)} />
        </>
    )
}

export default OtpInputs;